import React, { createElement as _createElement } from 'react';
import { ElementRenderer } from "../index.js";
import { GridItem } from "../../../grid/components/GridItem.js";
import { useShouldRenderElement } from "../../utils/shouldRender.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomGridItem({
  child,
  index,
  control,
  isFormDisabled,
  isLoading,
  useSmallFields,
  showCheckmark
}) {
  const shouldRender = useShouldRenderElement(child);
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_createElement(GridItem, {
    ...child.gridItemProps,
    key: child.id || `element-${index}`
  }, /*#__PURE__*/_jsx(ElementRenderer, {
    element: child,
    loading: isLoading,
    showCheckmark: showCheckmark,
    control,
    isFormDisabled,
    isLoading,
    useSmallFields
  }));
}